import React, { createContext, useContext, useEffect, useRef } from "react";
import { io, Socket } from "socket.io-client";

const SocketContext = createContext<Socket | null>(null);

export const SocketProvider = ({ currentUser, children }: { currentUser: any, children: React.ReactNode }) => {
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (!currentUser?.id) return;
    socketRef.current = io("https://hitmeup-backend.fly.dev", {
      query: { userId: currentUser.id },
      transports: ["websocket", "polling"],
    });
    return () => {
      socketRef.current?.disconnect();
    };
  }, [currentUser?.id]);

  return (
    <SocketContext.Provider value={socketRef.current}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);